import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  PublishersConfigsList: lazyNamed(() => import('./pages/PublishersConfigsList'), 'PublishersConfigsList'),
  PublisherConfigDetails: lazyNamed(() => import('./pages/PublisherConfigDetails'), 'PublisherConfigDetails'),
  AdConfigForm: lazyNamed(() => import('./pages/AdConfigForm'), 'AdConfigForm'),
  PublisherConfigForm: lazyNamed(() => import('./pages/PublisherConfigForm'), 'PublisherConfigForm'),
};
